import React, { useMemo, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Grid, Button, Box
} from '@mui/material';
import { ICON_MAP } from '../icons/sidebarIcons';
import { useTranslation } from 'react-i18next';

const OPTIONS = Object.keys(ICON_MAP).filter(k => k !== 'default');

export default function IconPicker({ open, onClose, value, onSelect }) {
  const { t } = useTranslation();
  const [q, setQ] = useState('');
  const filtered = useMemo(
    () => OPTIONS.filter(k => k.toLowerCase().includes(q.toLowerCase())),
    [q]
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('iconPicker.title')}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          size="small"
          label={t('iconPicker.search')}
          value={q}
          onChange={(e) => setQ(e.target.value)}
          sx={{ my: 2 }}
        />
        <Grid container spacing={2}>
          {filtered.map((key) => {
            const Icon = ICON_MAP[key];
            return (
              <Grid item xs={3} key={key}>
                <Box
                  onClick={() => { onSelect(key); onClose(); }}
                  sx={{
                    border: value === key ? '2px solid #d5c6a9' : '1px solid #eee',
                    borderRadius: 2,
                    p: 2,
                    textAlign: 'center',
                    cursor: 'pointer',
                    '& svg': { width: 24, height: 24, color: '#4b4843' },
                  }}
                >
                  <Icon />
                  <Box sx={{ fontSize: 12, mt: 1, color: '#666' }}>{key}</Box>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('iconPicker.close')}</Button>
      </DialogActions>
    </Dialog>
  );
}
